import { useMemo } from "react";
import { useProfileContext } from "../../../context/ProfileContext";

const WordImage = () => {
  const { currentWord } = useProfileContext();
  const imageURL = useMemo(() => {
    if (currentWord && currentWord.image) {
      return URL.createObjectURL(currentWord.image);
    }
    return null;
  }, [currentWord]);

  const handleImageLoad = () => {
    if (imageURL) {
      URL.revokeObjectURL(imageURL);
    }
  };

  return (
    <div className="relative mb-6 flex justify-center">
      <img
        src={imageURL ?? ""}
        onLoad={handleImageLoad}
        alt={currentWord?.english}
        width={100}
        height={100}
      />
    </div>
  );
};

export default WordImage;
